import { StationTestDto, TestDeviceScenario } from './constants';

export const convertRawTestDataToSattionTestDto = (stationData, stationTestData): StationTestDto => {
  const compressorGroupedTestData = groupTestResultPerCompressor(stationTestData);

  const groupedByFlowSensor = groupCompressorsByFlowSensor(compressorGroupedTestData);

  const stationTestResponse = updateCompressorsWithDeviceDetails(groupedByFlowSensor, stationData);
  return stationTestResponse;
};

export const groupTestResultPerCompressor = mockStationTestData => {
  const transformedDevices = transformTestDevices(mockStationTestData.testDevicesScenario);

  return {
    id: mockStationTestData.id,
    stationId: mockStationTestData.stationId,
    isRunning: mockStationTestData.isRunning,
    isSubmitted: mockStationTestData.isSubmitted,
    startedAt: mockStationTestData.startedAt,
    endedAt: mockStationTestData.endedAt,
    testDevicesScenario: transformedDevices,
  };
};

export const transformTestDevices = devices => {
  const transformedDevices = {};
  const flowSensorMap = {};
  const flowSensorNameMap = {};

  const powerSensorMap = {};
  const powerSensorNameMap = {};

  devices.forEach(device => {
    if (device.groupFlowSensorId) {
      flowSensorMap[device.deviceId] = device.groupFlowSensorId;
    }
    if (device.flowSensorName) {
      flowSensorNameMap[device.deviceId] = device.flowSensorName;
    }
  });

  devices.forEach(device => {
    if (device.groupPowerSensorId) {
      powerSensorMap[device.deviceId] = device.groupPowerSensorId;
    }
    if (device.powerSensorName) {
      powerSensorNameMap[device.deviceId] = device.powerSensorName;
    }
  });

  devices.forEach(device => {
    const { deviceId, parameter } = device;

    if (!transformedDevices[deviceId]) {
      transformedDevices[deviceId] = {
        deviceId: device.deviceId,
        compressorName: device.compressorName,
        compressorConnectivity: device.compressorConnectivity,
        groupPowerSensorId: powerSensorMap[deviceId] || null,
        groupFlowSensorId: flowSensorMap[deviceId] || null,
        stationTest: device.stationTest,
        flowSensorName: flowSensorNameMap[deviceId] || null,
        powerSensorName: powerSensorNameMap[deviceId] || null,
      };
    }

    transformedDevices[deviceId][parameter] = {
      id: device.id,
      status: device.status,
      value: device.value,
      comment: device.comment,
      realValue: device.realValue,
      expectValue: device.expectValue,
    };
  });

  return Object.values(transformedDevices);
};

export const groupCompressorsByFlowSensor = data => {
  const groupMap = new Map();

  data.testDevicesScenario.forEach(device => {
    const groupKey = device.groupFlowSensorId || null;

    if (!groupMap.has(groupKey)) {
      groupMap.set(groupKey, {
        groupFlowSensorId: groupKey,
        flowSensorName: device.flowSensorName,
        compressors: [],
      });
    }

    groupMap.get(groupKey).compressors.push(device);
  });

  const processedGroups = Array.from(groupMap.values()).map(group => {
    if (group.groupFlowSensorId) {
      const flowStatuses = group.compressors.map(comp => comp.FLOW);
      const flowStatusWithComments = flowStatuses.find(flow => flow.comment);
      group.FLOW = flowStatusWithComments || flowStatuses[0];
    }
    return group;
  });

  data.testDevicesScenario = processedGroups;
  return data;
};

export const updateCompressorsWithDeviceDetails = (stationTestData, stationData) => {
  stationTestData.testDevicesScenario.forEach(scenario => {
    scenario.compressors.forEach(compressor => {
      const matchingDevice = stationData.devices.find(device => device.deviceId === compressor.deviceId);
      if (matchingDevice) {
        compressor.elementIndex = matchingDevice.elementIndex;
        compressor.modelDisplayName = matchingDevice.modelDisplayName;
        compressor.brand = matchingDevice.brand;
        const modelDisplay = compressor.modelDisplayName || '';
        const brandValue = compressor.brand || '';
        compressor.modelName =
          modelDisplay && brandValue ? `${modelDisplay} ${brandValue}` : `${modelDisplay}${brandValue}`;
      }
    });
  });

  const reArrangedTestData = rearrangeTestDevicesScenario(stationTestData.testDevicesScenario as TestDeviceScenario[]);

  stationTestData.testDevicesScenario = reArrangedTestData;
  return stationTestData;
};

export const rearrangeTestDevicesScenario = (testDevicesScenario: TestDeviceScenario[]) => {
  const sortedScenarios = [...testDevicesScenario];

  sortedScenarios.sort((a, b) => {
    const minIndexA = Math.min(
      ...a.compressors.map(compressor =>
        typeof compressor.elementIndex === 'number' ? compressor.elementIndex : Infinity,
      ),
    );
    const minIndexB = Math.min(
      ...b.compressors.map(compressor =>
        typeof compressor.elementIndex === 'number' ? compressor.elementIndex : Infinity,
      ),
    );

    return minIndexA - minIndexB;
  });

  sortedScenarios.forEach(scenario => {
    scenario.compressors.sort((compressorA, compressorB) => {
      const indexA = typeof compressorA.elementIndex === 'number' ? compressorA.elementIndex : Infinity;
      const indexB = typeof compressorB.elementIndex === 'number' ? compressorB.elementIndex : Infinity;

      return indexA - indexB;
    });
  });

  return sortedScenarios;
};
